import React from 'react';

export default function Logo() {
  return (
    <div className="text-center" style={{ marginBottom: '10px' }}>
      <img src="/sacateun7.png" alt="Logo de Sácateun7" />
    </div>
  );
}
